const ProsEvents = {
  dataAvailable: '-data-available',
  failure: '-failure',
  success: '-success',
  recommendationCallSuccess: 'recommendation-call-success',
  recommendationCallFailure: 'recommendation-call-failure',
  PAGE_INFORMATION: 'page-information',
  gatherLoadedProducts: 'gatherLoadedProducts',
  dispatchPixelAnalyticsEvent: 'dispatchPixelAnalyticsEvent',
};

export default ProsEvents;
